var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z",
    fill: "#F3BA2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6015 12.6035L14 9.205L17.4002 12.6053L19.3778 10.6277L14 5.25L8.624 10.626L10.6015 12.6035ZM5.25 14L7.2275 12.0225L9.205 14L7.2275 15.9775L5.25 14ZM10.6015 15.3965L14 18.795L17.4002 15.3947L19.3778 17.3714L14 22.75L8.624 17.374L8.62137 17.3714L10.6015 15.3965ZM18.795 14L20.7725 12.0225L22.75 14L20.7725 15.9775L18.795 14ZM16.0055 13.9983H16.0073V14L14 16.0073L11.9954 14.0035L11.9919 14L11.9954 13.9974L12.3462 13.6456L12.5169 13.475L14 11.9928L16.0064 13.9991L16.0055 13.9983Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsc);
export default __webpack_public_path__ + "static/media/bsc.2cfc346f18f2fda8a6e8a6dc1d7ad4d2.svg";
export { ForwardRef as ReactComponent };